import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './nigeria-stockbroking-market-summary.component.scss';
import axios from 'axios';
import * as _ from 'lodash';
var NigeriaStockbrokingMarketSummary = /** @class */ (function (_super) {
    tslib_1.__extends(NigeriaStockbrokingMarketSummary, _super);
    function NigeriaStockbrokingMarketSummary(element) {
        return _super.call(this, element) || this;
    }
    NigeriaStockbrokingMarketSummary.prototype.init = function () {
        var _this = this;
        this.containerLosers = this.element.querySelector('#losers');
        this.containerGainers = this.element.querySelector('#gainers');
        this.containerGainersLosers = this.element.querySelector('#gainers-losers');
        this.containerDateTitle = Array.from(this.element.querySelectorAll('.nigeria-stockbroking-market-summary__date'));
        if (this.containerLosers && this.containerGainers) {
            this.promiseGainersLosers().then(function (response) {
                _this.getGainers(response, _this.containerGainers, _this.containerDateTitle);
                _this.getLosers(response, _this.containerLosers, _this.containerDateTitle);
            });
        }
        if (this.containerGainersLosers) {
            this.promiseGainersLosers().then(function (response) {
                _this.getGainersLosers(response, _this.containerGainersLosers, _this.containerDateTitle);
            });
        }
    };
    NigeriaStockbrokingMarketSummary.prototype.bindEvents = function () { };
    // Promise
    NigeriaStockbrokingMarketSummary.prototype.promiseGainersLosers = function () {
        var urlLosers = "https://feeds.standardbank.com/Market-Data-Files/NSB/Rates/lowNGAStock.json";
        var urlGainers = "https://feeds.standardbank.com/Market-Data-Files/NSB/Rates/topNGAStock.json";
        var axiosLosers = axios.get(urlLosers);
        var axiosGainers = axios.get(urlGainers);
        return Promise.all([axiosLosers, axiosGainers]);
    };
    // Get Top 5 Losers
    NigeriaStockbrokingMarketSummary.prototype.getLosers = function (response, container, containerDateTitle) {
        if (response === void 0) { response = []; }
        if (container === void 0) { container = undefined; }
        if (containerDateTitle === void 0) { containerDateTitle = undefined; }
        var output = "";
        var arrayLosers = response[0].data;
        var dateRaw = "";
        output += "<tr>\n\t\t\t<td class=\"table-context__table-heading\">Symbol</td>\n\t\t\t<td class=\"table-context__table-heading\">PClose</td>\n\t\t\t<td class=\"table-context__table-heading\">Close</td>\n\t\t\t<td class=\"table-context__table-heading\">Loss</td>\n\t\t\t<td class=\"table-context__table-heading\">%Change</td>\n\t\t</tr>";
        if (arrayLosers.DataTable) {
            var rowsLosers = arrayLosers.DataTable.Rows;
            var newArrayLosers_1 = [];
            rowsLosers.map(function (item) {
                dateRaw = item[5];
                var symbol = item[0];
                var pClose = parseFloat(item[3]).toFixed(2);
                var close = parseFloat(item[4]).toFixed(2);
                var loss = parseFloat(item[6]).toFixed(2);
                var change = parseFloat(item[7]).toFixed(2);
                var object = {
                    'symbol': symbol,
                    'pclose': pClose,
                    'close': close,
                    'loss': loss,
                    'change': change
                };
                newArrayLosers_1.push(object);
            });
            // let sortedRowsLosers: any = _.orderBy(newArrayLosers, ['change'], ['desc']);
            var sortedRowsLosers = newArrayLosers_1;
            for (var index = 0; index < 5; index++) {
                var item = sortedRowsLosers[index];
                output += "<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.symbol + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.pclose + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.close + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"nigeria-stockbroking-market-summary__column--loss\">\n\t\t\t\t\t\t" + item.loss + "\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-arrow-down-red\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon \">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"28\" viewBox=\"0 0 24 28\">\n\t\t\t\t\t\t\t\t<path fill=\"#D0021B\" fill-rule=\"nonzero\" d=\"M.5 16.35l1.627-1.65 8.714 8.834V0h2.302v23.534l8.73-8.85 1.627 1.65L11.992 28 .5 16.35\"></path>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.change + "\n\t\t\t\t\t</td>\n\t\t\t\t</tr>";
            }
            containerDateTitle.map(function (item) {
                var todaysDay = new Date(dateRaw);
                var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var valDate = monthNames[todaysDay.getMonth()] + " " + todaysDay.getDate() + ", " + todaysDay.getFullYear();
                item.innerHTML = "As at " + valDate;
            });
        }
        else {
            output += "<tr>\n\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t<p>No information</p>\n\t\t\t\t</td>\n\t\t\t</tr>";
        }
        container.innerHTML = output;
    };
    // Get Top 5 Gainers
    NigeriaStockbrokingMarketSummary.prototype.getGainers = function (response, container, containerDateTitle) {
        if (response === void 0) { response = []; }
        if (container === void 0) { container = undefined; }
        if (containerDateTitle === void 0) { containerDateTitle = undefined; }
        var output = "";
        var arrayGainers = response[1].data;
        var dateRaw = "";
        output += "<tr>\n\t\t\t<td class=\"table-context__table-heading\">Symbol</td>\n\t\t\t<td class=\"table-context__table-heading\">PClose</td>\n\t\t\t<td class=\"table-context__table-heading\">Close</td>\n\t\t\t<td class=\"table-context__table-heading\">Loss</td>\n\t\t\t<td class=\"table-context__table-heading\">%Change</td>\n\t\t</tr>";
        if (arrayGainers.DataTable) {
            var rowsGainers = arrayGainers.DataTable.Rows;
            var newArrayGainers_1 = [];
            rowsGainers.map(function (item) {
                dateRaw = item[5];
                var symbol = item[0];
                var pClose = parseFloat(item[3]).toFixed(2);
                var close = parseFloat(item[4]).toFixed(2);
                var gain = parseFloat(item[6]).toFixed(2);
                var change = parseFloat(item[7]).toFixed(2);
                var object = {
                    'symbol': symbol,
                    'pclose': pClose,
                    'close': close,
                    'gain': gain,
                    'change': change
                };
                newArrayGainers_1.push(object);
            });
            // let sortedRowsGainers: any = _.orderBy(newArrayGainers, ['change'], ['desc']);
            var sortedRowsGainers = newArrayGainers_1;
            for (var index = 0; index < 5; index++) {
                var item = sortedRowsGainers[index];
                output += "<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.symbol + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.pclose + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.close + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"nigeria-stockbroking-market-summary__column--gain\">\n\t\t\t\t\t\t" + item.gain + "\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-arrow-up-green\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon \">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"28\" viewBox=\"0 0 24 28\">\n    \t\t\t\t\t\t\t<path fill=\"#00AD6C\" fill-rule=\"nonzero\" d=\"M.5 11.65l1.627 1.65 8.714-8.834V28h2.302V4.466l8.73 8.85 1.627-1.65L11.992 0 .5 11.65\"></path>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.change + "\n\t\t\t\t\t</td>\n\t\t\t\t</tr>";
            }
            containerDateTitle.map(function (item) {
                var todaysDay = new Date(dateRaw);
                var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var valDate = monthNames[todaysDay.getMonth()] + " " + todaysDay.getDate() + ", " + todaysDay.getFullYear();
                item.innerHTML = "As at " + valDate;
            });
        }
        else {
            output += "<tr>\n\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t<p>No information</p>\n\t\t\t\t</td>\n\t\t\t</tr>";
        }
        container.innerHTML = output;
    };
    // Get Top Gainer & Loser
    NigeriaStockbrokingMarketSummary.prototype.getGainersLosers = function (response, container, containerDateTitle) {
        if (response === void 0) { response = []; }
        if (container === void 0) { container = undefined; }
        if (containerDateTitle === void 0) { containerDateTitle = undefined; }
        var output = "";
        var arrayLosers = response[0].data;
        var arrayGainers = response[1].data;
        var dateRaw = "";
        output += "<tr>\n\t\t\t<td class=\"table-context__table-heading\">Symbol</td>\n\t\t\t<td class=\"table-context__table-heading\">PClose</td>\n\t\t\t<td class=\"table-context__table-heading\">Close</td>\n\t\t\t<td class=\"table-context__table-heading\">Loss</td>\n\t\t\t<td class=\"table-context__table-heading\">%Change</td>\n\t\t</tr>";
        if (arrayGainers.DataTable) {
            var rowsGainers = arrayGainers.DataTable.Rows;
            var newArrayGainers_2 = [];
            rowsGainers.map(function (item) {
                dateRaw = item[5];
                var symbol = item[0];
                var pClose = parseFloat(item[3]).toFixed(2);
                var close = parseFloat(item[4]).toFixed(2);
                var gain = parseFloat(item[6]).toFixed(2);
                var change = parseFloat(item[7]).toFixed(2);
                var object = {
                    'symbol': symbol,
                    'pclose': pClose,
                    'close': close,
                    'gain': gain,
                    'change': change
                };
                newArrayGainers_2.push(object);
            });
            var sortedRowsGainers = _.orderBy(newArrayGainers_2, ['change'], ['desc']);
            for (var index = 0; index < 1; index++) {
                var item = sortedRowsGainers[index];
                output += "<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.symbol + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.pclose + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.close + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"nigeria-stockbroking-market-summary__column--gain\">\n\t\t\t\t\t\t" + item.gain + "\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-arrow-up-green\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon \">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"28\" viewBox=\"0 0 24 28\">\n    \t\t\t\t\t\t\t<path fill=\"#00AD6C\" fill-rule=\"nonzero\" d=\"M.5 11.65l1.627 1.65 8.714-8.834V28h2.302V4.466l8.73 8.85 1.627-1.65L11.992 0 .5 11.65\"></path>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.change + "\n\t\t\t\t\t</td>\n\t\t\t\t</tr>";
            }
            containerDateTitle.map(function (item) {
                var todaysDay = new Date(dateRaw);
                var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var valDate = monthNames[todaysDay.getMonth()] + " " + todaysDay.getDate() + ", " + todaysDay.getFullYear();
                item.innerHTML = "As at " + valDate;
            });
        }
        if (arrayLosers.DataTable) {
            var rowsLosers = arrayLosers.DataTable.Rows;
            var newArrayLosers_2 = [];
            rowsLosers.map(function (item) {
                dateRaw = item[5];
                var symbol = item[0];
                var pClose = parseFloat(item[3]).toFixed(2);
                var close = parseFloat(item[4]).toFixed(2);
                var loss = parseFloat(item[6]).toFixed(2);
                var change = parseFloat(item[7]).toFixed(2);
                var object = {
                    'symbol': symbol,
                    'pclose': pClose,
                    'close': close,
                    'loss': loss,
                    'change': change
                };
                newArrayLosers_2.push(object);
            });
            // let sortedRowsLosers: any = _.orderBy(newArrayLosers, ['change'], ['desc']);
            var sortedRowsLosers = _.orderBy(newArrayLosers_2, ['change'], ['desc']);
            for (var index = 0; index < 1; index++) {
                var item = sortedRowsLosers[index];
                output += "<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.symbol + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.pclose + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.close + "\n\t\t\t\t\t</td>\n\t\t\t\t\t<td class=\"nigeria-stockbroking-market-summary__column--loss\">\n\t\t\t\t\t\t" + item.loss + "\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-arrow-down-red\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon \">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"28\" viewBox=\"0 0 24 28\">\n\t\t\t\t\t\t\t\t<path fill=\"#D0021B\" fill-rule=\"nonzero\" d=\"M.5 16.35l1.627-1.65 8.714 8.834V0h2.302v23.534l8.73-8.85 1.627 1.65L11.992 28 .5 16.35\"></path>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t" + item.change + "\n\t\t\t\t\t</td>\n\t\t\t\t</tr>";
            }
            containerDateTitle.map(function (item) {
                var todaysDay = new Date(dateRaw);
                var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var valDate = monthNames[todaysDay.getMonth()] + " " + todaysDay.getDate() + ", " + todaysDay.getFullYear();
                item.innerHTML = "As at " + valDate;
            });
        }
        container.innerHTML = output;
    };
    return NigeriaStockbrokingMarketSummary;
}(Base));
export { NigeriaStockbrokingMarketSummary };



//////////////////
// WEBPACK FOOTER
// ./components-nigeria/nigeria-stockbroking-market-summary/nigeria-stockbroking-market-summary.component.ts
// module id = 653
// module chunks = 0